import { gql } from 'graphql-request';

export default gql`query {
    catalogPdf {
        label
        url
        type
    }
}`;